import {
  ALERT_SEVERITY,
  ALERT_TEXT,
  AlertColors,
  Field,
  FlightDataEntry,
  FlightProblems,
  FlightStatus,
  MINIMUM_DELAY_IN_HOURS,
} from "@/core/types/types";
import Alert from "@/core/components/Alert/Alert";
import { differenceInHours } from "date-fns";

interface PreselectedAlertComponentProps {
  field: Field;
  preselectedValue?: string;
  flightDataEntry: FlightDataEntry;
  selectedStatus: FlightProblems;
}

export const PreselectedAlertComponent: React.FC<
  PreselectedAlertComponentProps
> = ({ field, preselectedValue, flightDataEntry, selectedStatus }) => {
  const { flightSearchResult } = flightDataEntry ?? {};

  const generateAlertProps = (severity: AlertColors, text: string) => ({
    ...field,
    id: `alert${field.id}`,
    properties: {
      [ALERT_SEVERITY]: severity,
      [ALERT_TEXT]: text,
    },
  });

  const status: string | undefined = flightSearchResult?.status.toUpperCase();

  if (selectedStatus === FlightProblems.MissedConnection) {
    if (preselectedValue === FlightProblems.MissedConnection) {
      return (
        <Alert
          field={generateAlertProps(
            AlertColors.Success,
            "alert.selected.missed_connection.success"
          )}
        />
      );
    } else {
      return null;
    }
  }
  if (!status || status == FlightStatus.Unknown.toUpperCase()) {
    return null;
  }
  if (status && status !== selectedStatus) {
    return (
      <Alert
        field={generateAlertProps(
          AlertColors.Warning,
          "alert.selected.warning"
        )}
      />
    );
  }
  if (preselectedValue && preselectedValue === FlightProblems.Delayed) {
    const scheduled: Date = new Date(
      flightSearchResult?.scheduledArrival ?? ""
    );
    const actual: Date = new Date(flightSearchResult?.actualArrival ?? "");

    const hasDelay: boolean =
      differenceInHours(actual, scheduled) >= MINIMUM_DELAY_IN_HOURS;
    if (hasDelay) {
      return (
        <Alert
          field={generateAlertProps(
            AlertColors.Success,
            "alert.selected.delay.success"
          )}
        />
      );
    }
  }
  if (preselectedValue && preselectedValue === FlightProblems.Cancelled) {
    return (
      <Alert
        field={generateAlertProps(
          AlertColors.Success,
          "alert.selected.cancelled.success"
        )}
      />
    );
  }

  return null;
};
